<ion-content class="ff-tartalom">
  <div class="ff-doboz">
    <div class="ff-ikon"><ion-spinner name="crescent"></ion-spinner></div>
    <h1>Frissítés folyamatban</h1>
    <p class="ff-uzenet">{{ uzenet }}</p>
    <p class="ff-lepes" *ngIf="lepes">Épp most: <b>{{ lepes }}</b></p>
    <p class="ff-nyugtato">
      Nem kell semmit tenned, és a böngészőt sem kell frissítened — ez az oldal
      <b>magától visszaenged</b>, amint a frissítés befejeződött.
    </p>
    <p class="ff-ido">Elkezdődött {{ elteltSzoveg }}.</p>
  </div>
</ion-content>
